/* Pouch & Spark: homepage card carousels (Dawn featured-collection <slider-component>s).
   No autoplay (user, 2026-09-26). Instead:
   - scroll affordance: edge fades on the side(s) that have more cards + round side arrows (desktop)
   - desktop mouse: click-and-drag to scroll (a drag never opens a card; a plain click still does)
   Trackpad / shift+wheel horizontal scrolling keeps working natively. */
(function () {
  function setup(sc) {
    var slider = sc.querySelector('[id^="Slider-"]');
    if (!slider) return;
    sc.classList.add('pv-cc');

    // side arrows (desktop) — scroll by ~one view
    function arrow(dir) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'pv-cc-arrow pv-cc-arrow--' + dir;
      b.setAttribute('aria-label', dir === 'prev' ? 'Scroll left' : 'Scroll right');
      b.innerHTML = '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="' + (dir === 'prev' ? 'M15 5l-7 7 7 7' : 'M9 5l7 7-7 7') + '"/></svg>';
      b.addEventListener('click', function () {
        slider.scrollBy({ left: (dir === 'prev' ? -1 : 1) * Math.max(200, slider.clientWidth * 0.85), behavior: 'smooth' });
      });
      sc.appendChild(b);
      return b;
    }
    var prev = arrow('prev'), next = arrow('next');

    function update() {
      var max = slider.scrollWidth - slider.clientWidth;
      var scrollable = max > 4;
      var atStart = slider.scrollLeft <= 4, atEnd = slider.scrollLeft >= max - 4;
      sc.classList.toggle('pv-cc--scrollable', scrollable);
      sc.classList.toggle('pv-cc--more-left', scrollable && !atStart);
      sc.classList.toggle('pv-cc--more-right', scrollable && !atEnd);
      prev.hidden = !scrollable || atStart;
      next.hidden = !scrollable || atEnd;
    }
    slider.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
    setTimeout(update, 600);

    // desktop mouse drag-to-scroll
    var down = false, dragged = false, startX = 0, startLeft = 0;
    slider.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      down = true; dragged = false; startX = e.clientX; startLeft = slider.scrollLeft;
    });
    window.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      if (!dragged && Math.abs(dx) > 6) {
        dragged = true;
        sc.classList.add('pv-cc--dragging'); // disables scroll-snap + smooth scrolling while dragging
      }
      if (dragged) { slider.scrollLeft = startLeft - dx; e.preventDefault(); }
    });
    window.addEventListener('pointerup', function () {
      if (!down) return;
      down = false;
      if (dragged) {
        sc.classList.remove('pv-cc--dragging');
        // snap to the nearest card after the drag
        var s = slider.querySelector('.slider__slide');
        var step = s ? s.getBoundingClientRect().width + parseFloat(getComputedStyle(slider).columnGap || 0) : 0;
        if (step) slider.scrollTo({ left: Math.round(slider.scrollLeft / step) * step, behavior: 'smooth' });
      }
    });
    // a drag must not count as a click on a card/link
    slider.addEventListener('click', function (e) {
      if (dragged) { e.preventDefault(); e.stopPropagation(); dragged = false; }
    }, true);
    // stop the browser's native image/link drag ghost
    slider.addEventListener('dragstart', function (e) { e.preventDefault(); });
  }

  function init() {
    document.querySelectorAll('main slider-component').forEach(function (sc) {
      if (sc.closest('.collection') && !sc.dataset.pvCc) {
        sc.dataset.pvCc = '1';
        setup(sc);
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
